/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-30 14:39:24
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-11-02 17:24:03
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/ProductSelectionNoPagination/GeneralSalesChannelProductSelection/Col.tsx
 */

import React from 'react';
import TagGroup from 'src/components/TagGroup/TagGroup';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
//import { get } from 'lodash';
import css from './col.module.less';
import { EnumFilterType } from 'src/constrains/Query1/Filter';
import { EyeOutlined } from '@ant-design/icons';
import { Icon } from '@/src/tools/icon';

export const mockData1 = [
  {
    uuid: '6bf3bb3a-433c-4b4e-85c2-199d4e8f005e',
    createdBy: '1',
    modifiedBy: '1',
    createdDate: '2021-06-04 18:11:59',
    modifiedDate: '2021-08-27 19:03:52',
    valid: true,
    deleted: false,
    storeUuid: '1',
    salesChannelUuid: '9113a476-a82d-4fa8-95fd-1ace568e75be',
    salesChannelName: null,
    currency: null,
    hasError: false,
    errorDetail: {},
    otherLocaleErrors: null,
    visible: false,
    productType: 'Multiple',
    content: null,
    customisation: null,
    productName: "AS'1",
    image: null,
    thumbnailUrl: null,
    salesChannelProductReview: null,
    listPrice: null,
    available: null,
    sku: null,
    tags: [
      {
        uuid: '50aea408-806c-4681-8376-7e0fb436e856',
        createdBy: '1',
        modifiedBy: '1',
        createdDate: '2021-02-25 11:09:59',
        modifiedDate: '2021-02-25 11:09:59',
        valid: true,
        deleted: false,
        storeUuid: '1',
        name: 'aa',
      },
      {
        uuid: '292202de-66fb-4854-bfa2-9669fbc6b96f',
        createdBy: '1',
        modifiedBy: '1',
        createdDate: '2021-02-25 11:47:15',
        modifiedDate: '2021-02-25 11:47:15',
        valid: true,
        deleted: false,
        storeUuid: '1',
        name: 'fddf',
      },
    ],
    children: [
      {
        uuid: '2c1c1de7-4951-4b1d-8cc7-e753dcf2946c',
        createdBy: null,
        modifiedBy: null,
        createdDate: null,
        modifiedDate: null,
        valid: false,
        deleted: false,
        storeUuid: null,
        salesChannelUuid: null,
        salesChannelName: null,
        currency: null,
        hasError: false,
        errorDetail: null,
        otherLocaleErrors: null,
        visible: true,
        productType: 'Single',
        content: null,
        customisation: null,
        productName: "Albert's test",
        image: null,
        thumbnailUrl: null,
        salesChannelProductReview: null,
        listPrice: 10,
        available: 110,
        sku: 'aaa111',
        tags: [],
        children: null,
        productUuid: '2c1c1de7-4951-4b1d-8cc7-e753dcf2946c',
        child: true,
        alias: false,
      },
      {
        uuid: '5b6c089f-e3cd-47c5-ac24-5d411b386fdc',
        createdBy: null,
        modifiedBy: null,
        createdDate: null,
        modifiedDate: null,
        valid: false,
        deleted: false,
        storeUuid: null,
        salesChannelUuid: null,
        salesChannelName: null,
        currency: null,
        hasError: false,
        errorDetail: null,
        otherLocaleErrors: null,
        visible: true,
        productType: 'Single',
        content: null,
        customisation: null,
        productName: 'Simple test',
        image: null,
        thumbnailUrl:
          'https://image-uat.unifyxp.com/images/Product/0b355e07-84bb-469c-92ce-e7b1657a273a.jpeg',
        salesChannelProductReview: null,
        listPrice: 210,
        available: null,
        sku: 'aa-test',
        tags: [
          {
            uuid: '50aea408-806c-4681-8376-7e0fb436e856',
            createdBy: '1',
            modifiedBy: '1',
            createdDate: '2021-02-25 11:09:59',
            modifiedDate: '2021-02-25 11:09:59',
            valid: true,
            deleted: false,
            storeUuid: '1',
            name: 'aa',
          },
          {
            uuid: '292202de-66fb-4854-bfa2-9669fbc6b96f',
            createdBy: '1',
            modifiedBy: '1',
            createdDate: '2021-02-25 11:47:15',
            modifiedDate: '2021-02-25 11:47:15',
            valid: true,
            deleted: false,
            storeUuid: '1',
            name: 'fddf',
          },
        ],
        children: null,
        productUuid: '5b6c089f-e3cd-47c5-ac24-5d411b386fdc',
        child: true,
        alias: false,
      },
      // {
      //   uuid: 'e0e1a044-e365-48ec-a82c-c787d6e61b64',
      //   createdBy: null,
      //   modifiedBy: null,
      //   createdDate: null,
      //   modifiedDate: null,
      //   valid: false,
      //   deleted: false,
      //   storeUuid: null,
      //   salesChannelUuid: null,
      //   salesChannelName: null,
      //   currency: null,
      //   hasError: false,
      //   errorDetail: null,
      //   otherLocaleErrors: null,
      //   visible: true,
      //   productType: 'Single',
      //   content: null,
      //   customisation: null,
      //   productName: '好认的名字',
      //   image: null,
      //   thumbnailUrl: null,
      //   salesChannelProductReview: null,
      //   listPrice: 10,
      //   available: 9000,
      //   sku: 'werfafwef',
      //   tags: [],
      //   children: null,
      //   productUuid: 'e0e1a044-e365-48ec-a82c-c787d6e61b64',
      //   child: true,
      //   alias: false,
      // },
    ],
    productUuid: null,
    child: false,
    alias: false,
  },
  {
    uuid: '771850eb-5cad-4b19-975a-c2fdbf46c96c',
    createdBy: '1',
    modifiedBy: '1',
    createdDate: '2021-05-27 17:38:41',
    modifiedDate: '2021-06-07 16:59:03',
    valid: true,
    deleted: false,
    storeUuid: '1',
    salesChannelUuid: '9113a476-a82d-4fa8-95fd-1ace568e75be',
    salesChannelName: null,
    currency: null,
    hasError: false,
    errorDetail: {},
    otherLocaleErrors: null,
    visible: false,
    productType: 'Multiple',
    content: null,
    customisation: null,
    productName: 'asdasd',
    image: null,
    thumbnailUrl: null,
    salesChannelProductReview: null,
    listPrice: null,
    available: null,
    sku: null,
    tags: [
      {
        uuid: '50aea408-806c-4681-8376-7e0fb436e856',
        createdBy: '1',
        modifiedBy: '1',
        createdDate: '2021-02-25 11:09:59',
        modifiedDate: '2021-02-25 11:09:59',
        valid: true,
        deleted: false,
        storeUuid: '1',
        name: 'aa',
      },
      {
        uuid: '292202de-66fb-4854-bfa2-9669fbc6b96f',
        createdBy: '1',
        modifiedBy: '1',
        createdDate: '2021-02-25 11:47:15',
        modifiedDate: '2021-02-25 11:47:15',
        valid: true,
        deleted: false,
        storeUuid: '1',
        name: 'fddf',
      },
    ],
    children: [
      {
        uuid: '5b6c089f-e3cd-47c5-ac24-5d411b386fdc',
        createdBy: null,
        modifiedBy: null,
        createdDate: null,
        modifiedDate: null,
        valid: false,
        deleted: false,
        storeUuid: null,
        salesChannelUuid: null,
        salesChannelName: null,
        currency: null,
        hasError: false,
        errorDetail: null,
        otherLocaleErrors: null,
        visible: true,
        productType: 'Single',
        content: null,
        customisation: null,
        productName: 'Simple test',
        image: null,
        thumbnailUrl:
          'https://image-uat.unifyxp.com/images/Product/0b355e07-84bb-469c-92ce-e7b1657a273a.jpeg',
        salesChannelProductReview: null,
        listPrice: 210,
        available: null,
        sku: 'aa-test',
        tags: [
          {
            uuid: '50aea408-806c-4681-8376-7e0fb436e856',
            createdBy: '1',
            modifiedBy: '1',
            createdDate: '2021-02-25 11:09:59',
            modifiedDate: '2021-02-25 11:09:59',
            valid: true,
            deleted: false,
            storeUuid: '1',
            name: 'aa',
          },
          {
            uuid: '292202de-66fb-4854-bfa2-9669fbc6b96f',
            createdBy: '1',
            modifiedBy: '1',
            createdDate: '2021-02-25 11:47:15',
            modifiedDate: '2021-02-25 11:47:15',
            valid: true,
            deleted: false,
            storeUuid: '1',
            name: 'fddf',
          },
        ],
        children: null,
        productUuid: '5b6c089f-e3cd-47c5-ac24-5d411b386fdc',
        child: true,
        alias: false,
      },
    ],
    productUuid: null,
    child: false,
    alias: false,
  },
];

export const mockData = [
  {
    thumbnailUrl: 'https://upload.fireflyau.com/web_gwpte/common/pte-logo.png',
    uuid: '1',
    productName: 'zhu zhu zhu zhu huz huz huz huz',
    sku: '',
    remarks: '1',
    tags: [{ name: '1', uuid: '1' }],
    alias: true,
    visible: true,
    children: [
      // {
      //   thumbnailUrl:
      //     'https://upload.fireflyau.com/web_gwpte/common/pte-logo.png',
      //   uuid: '3',
      //   productName:
      //     'Product NameProduct Name Product Name Product Name Product Name',
      //   sku: 'Product Product Product Product Product Product Product Product Product Product Product Product Product Product ',
      //   remarks:
      //     'Product Product Product Product Product Product Product Product Product Product ',
      //   tags: [{ name: '3', uuid: '3' }],
      //   alias: false,
      //   visible: false,
      // },
      {
        uuid: '2',
        productName: '2',
        sku: '2',
        remarks: '2',
        tags: [{ name: '2', uuid: '2' }],
        alias: false,
        visible: false,
      },
    ],
  },
  {
    thumbnailUrl: 'https://upload.fireflyau.com/web_gwpte/common/pte-logo.png',
    uuid: '2',
    productName: '2',
    sku: '2',
    remarks: '2',
    tags: [{ name: '2', uuid: '2' }],
    alias: false,
    visible: false,
    // children: [
    //   {
    //     thumbnailUrl:
    //       'https://upload.fireflyau.com/web_gwpte/common/pte-logo.png',
    //     uuid: '2',
    //     productName: '2',
    //     sku: '2',
    //     remarks: '2',
    //     tags: [{ name: '2', uuid: '2' }],
    //     alias: false,
    //     visible: false,
    //   },
    // ],
  },

  // onSelect
];

export const salesChannelColumns = ({ getI18n }) => [
  {
    title: getI18n('general.productName'),
    dataIndex: 'productName',
    default: true,
    sorter: (a, b) => {
      const name1 = a.productName || '';
      const name2 = b.productName || '';
      const n1 = name1.toLowerCase();
      const n2 = name2.toLowerCase();
      if (n1 > n2) return 1;
      if (n2 > n1) return -1;
      return 0;
    },

    className: css.expandRow,
    key: 'productName',
    childGenerate: (text, record) => {
      const { thumbnailUrl, productName } = record;
      const name = productName || '-';
      return (
        <div className={css.productNameContainer}>
          {thumbnailUrl && (
            <img
              style={{
                marginRight: 12,
              }}
              width={40}
              height={40}
              key={thumbnailUrl}
              src={thumbnailUrl}
              alt={thumbnailUrl}
            />
          )}
          <NoWrapContainer>
            <GlobalTooltip title={name}>
              <div className={css.text}>{name}</div>
            </GlobalTooltip>
          </NoWrapContainer>
        </div>
      );
    },

    width: 220,
  },
  {
    title: getI18n('general.sKU'),
    dataIndex: 'sku',
    default: true,

    key: 'sku',

    width: 100,
  },
  {
    title: getI18n('general.remarks'),
    dataIndex: 'remarks',
    default: true,
    key: 'remarks',
    width: 100,
  },
  {
    title: getI18n('general.tags'),
    dataIndex: 'tags',
    default: true,
    align: 'center',
    key: 'tags',
    width: 150,
    tags: true,
    tagsGenerator: (
      characterLength,
      width,
      marginPaddingWidth,
      containPaddingWidth,
      tags,
      record,
    ) => {
      return (
        <TagGroup
          characterLength={characterLength}
          containerWidth={width}
          marginPaddingWidth={marginPaddingWidth}
          containPaddingWidth={containPaddingWidth}
          tags={tags}
        />
      );
    },
  },
  {
    title: getI18n('general.alias'),
    default: true,
    key: 'alias',
    width: 72,
    childGenerate: (a, record) => {
      const { alias, child } = record;
      return <span>{child ? '' : alias ? getI18n('general.alias') : '-'}</span>;
    },
  },
  {
    title: getI18n('general.visibility'),
    default: true,
    key: 'Visibility',
    align: 'center',
    width: 80,
    childGenerate: (a, record) => {
      const { visible } = record;
      return (
        <div className={css.icon}>
          {visible ? (
            <EyeOutlined className={css.eye} />
          ) : (
            <Icon type={'iconinvisible'} />
          )}
        </div>
      );
    },
  },
];
const filterList = ({ tags, getI18n }) => [
  {
    type: EnumFilterType.MultipleSelection,
    dropdownProps: { name: getI18n('general.tags') },
    keyWord: 'tags',
    sortedByFirstLetter: true,
    options: tags.map((item) => ({
      label: item.name,
      value: item.uuid,
    })),
    searchable: true,
  },
  {
    type: EnumFilterType.SingleSelection,
    options: [
      {
        label: getI18n('general.alias'),
        value: 'alias-1',
      },
      {
        label: getI18n('general.notAlias'),
        value: 'alias-0',
      },
    ],
    dropdownProps: { name: getI18n('general.alias') },
    keyWord: 'alias',
  },
  {
    type: EnumFilterType.SingleSelection,
    options: [
      {
        label: getI18n('general.visible'),
        value: 'visible-1',
      },
      {
        label: getI18n('general.invisible'),
        value: 'visible-0',
      },
    ],
    dropdownProps: { name: getI18n('general.visibility') },
    keyWord: 'visible',
  },
];
export { filterList };
